import * as React from 'react';
import './LoadingIcon.scss';

export const LoadingIcon = () => (
  <div className="loading-icon" role="progressbar">
    <svg className="loading-icon--svg" viewBox="0 0 50 50">
      <circle
        className="loading-icon--circle"
        cx="25"
        cy="25"
        r="20"
        strokeWidth="2.5"
        fill="none"
      />
    </svg>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/LoadingIcon/LoadingIcon.tsx